import styled from 'styled-components';
import { Card, Badge, Row, Button } from 'antd';

export const ScoreboardContainer = styled.div`
  padding: 24px;
  background: #f0f2f5;
  min-height: 100vh;
`;

export const MatchesContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const MatchCard = styled(Card)<{ $isActive?: boolean; $isCompleted?: boolean }>`
  margin-bottom: 16px;
  border: ${props => props.$isActive ? '2px solid #1890ff' : '1px solid #e8e8e8'};
  border-radius: 12px;
  box-shadow: ${props => props.$isActive 
    ? '0 4px 12px rgba(24, 144, 255, 0.2), 0 8px 24px rgba(24, 144, 255, 0.1)' 
    : '0 1px 3px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.04)'};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  
  ${props => props.$isCompleted && `
    opacity: 0.7;
    background: #fafafa;
  `}
  
  &:hover {
    box-shadow: 
      0 4px 12px rgba(0, 0, 0, 0.08),
      0 8px 24px rgba(0, 0, 0, 0.04);
    transform: translateY(-2px);
  }
`;

export const ParticipantRow = styled.div<{ $isWinner?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  margin: 8px 0;
  background: ${props => props.$isWinner ? '#f6ffed' : '#fff'};
  border: 1px solid ${props => props.$isWinner ? '#b7eb8f' : '#d9d9d9'};
  border-radius: 4px;
  font-size: 16px;
  font-weight: ${props => props.$isWinner ? 'bold' : 'normal'};
`;

export const ParticipantInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ParticipantName = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

export const ParticipantDetails = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  display: flex;
  gap: 8px;
`;

export const ScoreDisplay = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #1890ff;
  margin: 0 16px;
`;

export const MatchInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
`;

export const TimerDisplay = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #ff4d4f;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusBadge = styled(Badge)`
  .ant-badge-status-dot {
    width: 10px;
    height: 10px;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const ConnectionStatus = styled.div<{ $connected: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${props => props.$connected ? '#52c41a' : '#ff4d4f'};
  font-weight: 500;
`;

export const StatsRow = styled(Row)`
  margin-bottom: 24px;
`;

export const WinnerButton = styled(Button)`
  margin-left: 8px;
  min-width: 120px;
  height: 40px;
  padding: 8px 20px;
  font-size: 16px;
  background-color: #52c41a !important;
  border-color: #52c41a !important;
  color: #ffffff !important;
  font-weight: 600;
  
  &:hover {
    background-color: #73d13d !important;
    border-color: #73d13d !important;
    color: #ffffff !important;
  }
  
  &:focus {
    background-color: #52c41a !important;
    border-color: #52c41a !important;
    color: #ffffff !important;
  }
`;

